import { render } from "./StepperEditor.vue?vue&type=template&id=189253e3&scoped=true"
import script from "./StepperEditor.vue?vue&type=script&lang=js"
export * from "./StepperEditor.vue?vue&type=script&lang=js"

import "./StepperEditor.vue?vue&type=style&index=0&id=189253e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189253e3"]])

export default __exports__